<mat-drawer-container autosize="true" hasBackdrop="false">
  <mat-drawer-content class="saksliste-og-detaljer-kontainer">
    <!-- merk at vi ikke putter saksliste i egen <mat-sidenav mode="side"> da vi ikke ønsker at sidenav skal styre scrolling.
         Når vi viser saksdetaljer (splittvisning) og vinduet er høyt nok står alt over listene fast (se markørklassen basisside-uiview__fast-hoeyde), og saksliste og saksdetaljer får hver sitt scrollområde (.saksliste-og-opprettsak-kontainer og .saksdetaljer-scrollomraade).
         Ved lav vindushøyde, og for utskrift, scroller hele siden som før. -->
    <!-- toggleKlasseVedScroll setter klassen har-scroll når sakslisten scroller, da skjules skillelinjen og scrollbaren (som står der skillelinjen står) fungerer som skille.
         cdkScrollable (også på .saksdetaljer-scrollomraade) gjør at menyer, tooltips o.l. (cdk overlay) reposisjoneres/lukkes ved scroll i scrollområdet -->
    <div class="saksliste-og-opprettsak-kontainer" toggleKlasseVedScroll cdkScrollable>
      @if (viserSaksdetaljer()) {
        <div class="møte" (click)="gaaTilMoete()">
          <button mat-icon-button class="mat-large-icon-button">
            <mat-icon>chevron_left</mat-icon>
          </button>
          <div class="informasjon__full">
            <div class="tittel">{{ moete().tittel }} {{ moete().nummer }} </div>
            <div class="dato">{{ moete().dato.start|zoneddatetime }}</div>
          </div>
          <!-- alternativ kompakt visning som brukes når vindusbredde < $smal-saksliste-grense eller nå vi er i presentasjonsmodus -->
          <div class="informasjon__kompakt">{{ 'møte'|translate }}</div>
        </div>
      }
      <saksliste [saker]="saker()" [kompakt]="viserSaksdetaljer()" [ekstraKompakt]="presentasjonsmodusAktivert() || viserDokumentdetaljer()" (vedSorteringAktivert)="vedSorteringAktivert($event)"/>
      @if(!nyeSakerSkjemaDeaktivert()){
        <nye-saker-skjema [moete]="moete()"
                          [visNySakTips]="saker().length == 0"
                          (vedVisFulltSkjemaAktivert)="vedVisFulltNyeSakerSkjema($event)"
                          (vedNyeSakerOpprettet)="vedNyeSakerOpprettet($event)"
                          class="ikke-print"
                          data-tips-id="ny-sak-skjema"/>
      }
    </div>
    @if(viserSaksdetaljer()){
      <div class="skillelinje"></div>
      <div class="saksdetaljer-scrollomraade" #saksdetaljerScrollomraade cdkScrollable>
        @if (aktivSakErPause()) {
          <pause-vis [id]="aktivSakId()!" animate.enter="ton-inn"/>
        } @else {
          <sak-vis [id]="aktivSakId()!" animate.enter="ton-inn"/>
        }
      </div>
    }
  </mat-drawer-content>
  <mat-drawer mode="side" position="end" disableClose="false" class="valgt-dokument-kontainer">
    <lukk-mat-drawer-knapp (click)="skjulDokumentDetaljer()"/>
    @if (viserDokumentdetaljer()) {
      <dokument-detaljer [dokumentversjon]="valgtDokument()!" [redigerbar]="kanRedigereDokument()"/>
    }
  </mat-drawer>
</mat-drawer-container>
